import React from "react";
import './Loading.scss'

const Loading = (props)=>{
const check = props.check
console.log("This is the final loading", check)
    return(
        <div className={!check ? 'loadingContainer' : 'loadingHide'}>
        <div className={'insideLoading'}>
            Loading...
        </div>
        </div>
    )

}

export default Loading
